import {
  Country,
} from "country-state-city";

import AutocompleteField from "../../../shared/forms/AutocompleteField";

import {
  annualIncomeOptions,
  workingStatusOptions,
} from "../../../shared/config/profileOptions";

const inputClass =
  "mt-1 block w-full rounded-xl border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 shadow-sm outline-none transition focus:border-amber-500 focus:ring-2 focus:ring-amber-500/20";

const CareerEducationSection = ({
  formData,
  updateField,
  setFieldValue,
  searchEducation,
  searchProfessions,
  searchDesignations,
}) => {
  const countries =
    Country.getAllCountries();

  return (
    <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
      <AutocompleteField
        label="Education"
        required
        value={formData.education}
        searchFn={searchEducation}
        placeholder="Start typing education"
        onChange={(value) =>
          setFieldValue(
            "education",
            value
          )
        }
      />

      <AutocompleteField
        label="Profession"
        required
        value={formData.profession}
        searchFn={searchProfessions}
        placeholder="Start typing profession"
        onChange={(value) =>
          setFieldValue(
            "profession",
            value
          )
        }
      />

      <AutocompleteField
        label="Designation"
        value={formData.designation}
        searchFn={searchDesignations}
        placeholder="Start typing designation"
        onChange={(value) =>
          setFieldValue(
            "designation",
            value
          )
        }
      />

      <label className="block text-sm font-medium text-slate-700">
        Current Company
        <input
          name="currentCompany"
          value={
            formData.currentCompany || ""
          }
          onChange={updateField}
          className={inputClass}
        />
      </label>

      <label className="block text-sm font-medium text-slate-700">
        Working Status
        <span className="ml-1 text-red-600">*</span>
        <select
          name="workingStatus"
          value={
            formData.workingStatus || ""
          }
          onChange={updateField}
          className={inputClass}
        >
          <option value="">
            Select
          </option>
          {workingStatusOptions.map(
            (option) => (
              <option
                key={option.value}
                value={option.value}
              >
                {option.label}
              </option>
            )
          )}
        </select>
      </label>

      <label className="block text-sm font-medium text-slate-700">
        Country Living In
        <select
          name="countryLivingIn"
          value={
            formData.countryLivingIn ||
            ""
          }
          onChange={updateField}
          className={inputClass}
        >
          <option value="">
            Select Country
          </option>
          {countries.map(
            (country) => (
              <option
                key={
                  country.isoCode
                }
                value={
                  country.isoCode
                }
              >
                {country.name}
              </option>
            )
          )}
        </select>
      </label>

      <label className="block text-sm font-medium text-slate-700">
        Annual Income
        <span className="ml-1 text-red-600">*</span>
        <select
          name="annualIncome"
          value={
            formData.annualIncome || ""
          }
          onChange={updateField}
          className={inputClass}
        >
          <option value="">
            Select
          </option>
          {annualIncomeOptions.map(
            (option) => (
              <option
                key={option.value}
                value={option.value}
              >
                {option.label}
              </option>
            )
          )}
        </select>
      </label>
    </div>
  );
};

export default CareerEducationSection;
